webpackJsonp([171],{

/***/ 1184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(111);




/* harmony default export */ __webpack_exports__["default"] = ({
  preFetch: function preFetch(_ref) {
    var store = _ref.store;

    return store.dispatch('updateContributors');
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['contributors']),
  head: {
    title: 'VUX 贡献者列表'
  }
});

/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(306)(false);
// imports


// module
exports.push([module.i, ".link[data-v-42871e9a]{color:#000;display:inline-block;width:120px}.count[data-v-42871e9a]{font-size:14px}.list[data-v-42871e9a]{list-style:none;padding-left:0}.list li[data-v-42871e9a]{margin:0;text-align:center;float:left;padding:15px 15px 15px 0}.avatar[data-v-42871e9a]{width:64px;height:64px;border-radius:40px}", ""]);

// exports


/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(307)("13165a20", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42871e9a\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./contributors.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42871e9a\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./contributors.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2188:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("贡献者列表"), _c('span', {
    staticClass: "count"
  }, [_vm._v(" (目前有 "), _c('code', [_vm._v(_vm._s(_vm.contributors.length))]), _vm._v(" 个有为青年贡献了代码)")])]), _c('div', {
    staticClass: "tip"
  }, [_vm._v("\n无论是编辑文档还是提交代码都可以帮助 VUX 做得更好。\n")]), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.contributors), function(user) {
    return _c('li', [_c('a', {
      staticClass: "link",
      attrs: {
        "href": user.html_url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": user.avatar_url
      }
    }), _c('br'), _c('span', [_vm._v(_vm._s(user.login))])])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42871e9a", module.exports)
  }
}

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1580)
}
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1184),
  /* template */
  __webpack_require__(2188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42871e9a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/en/about/contributors.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] contributors.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42871e9a", Component.options)
  } else {
    hotAPI.reload("data-v-42871e9a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 171.32f5d144.js